module.exports = __webpack_public_path__ + "img/success.c53162b.svg";